import workspaceQuery from '../../queries/sales/PaymentWorkspaceQuery.graphql';
import listQuery from '../../queries/sales/PaymentListQuery.graphql';

import printMutation from '../../mutations/sales/PaymentPrintMutation.graphql';
import reprintMutation from '../../mutations/sales/PaymentReprintMutation.graphql';

import * as printFunctions from '../../../actions/sales/PaymentAction';
import fragment from 'graphql/fragments/sales/PaymentFragment.graphql';
import { customerDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { DocumentNode } from 'graphql';

const Payment: EntityType & { print: DocumentNode } = {
  type: 'Payment',
  title: 'Payment',
  fragment,
  formUrl: '/Sales/Payments/Form/',
  formTitle: 'Payments',
  workspaceUrl: '/Sales/Payments/Workspace/',
  workspace: workspaceQuery,
  print: printMutation,
  reprint: reprintMutation,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
  },
  printFunctions: printFunctions,
  configuration: {
    title: 'Payment Receipt',
    field: 'paymentReceiptDefault',
    reportType: 'PAYMENT_RECEIPT',
    customerField: 'customerPaymentReceiptDefault',
    receiveFlag: 'receivePaymentReceipts',
  },
  mergeFields: [
    ...customerDocument,
    {
      key: 'salesOrderNumber',
      text: 'Sales Order Number',
    },
  ],
};

export default Payment;
